(function($){

    window.Application.Donate = {
        ui: {
            container: '.js-donate',
            nav: '.js-donate__nav',
            stepNav: '.js-donate__step-nav',
            step: '.js-donate__step',
            submit: '.js-donate__submit',
            submitContainer: '.js-donate__submit-container',
            alternativeContent: '.js-donate__alternative-content',
            dynamicContent: '.js-donate__dynamic-content',
            toggleContent: '.js-donate__toggle-content',
            checkboxToggle: '.js-donate__checkbox-toggle',
            checkboxToggleContent: '.js-donate__checkbox-toggle-content',
            cardForm: '.js-donate__card-form',
            paymentRequestButton: '.js-donate__payment-request-button',
            messages: '.js-donate__messages',
            thanksAmount: '.js-donate__thanks-amount',
            thanksPaymentReference: '.js-donate__thanks-payment-reference',
            logout: '.js-donate__logout',
        },
        url: {
            theme: null,
            submit: null,
            logout: null,
        },
        page_id: null,
        defaultErrorMessage: null,
        currentStepIndex: null,
        recaptchaSiteKey: null,
        defaultStep: 0,
        stripe: null,
        stripeElements: {},
        stripePaymentRequestEvent: null,
        values: {},
        ready: function () {

            var self = this;

            if (!$(this.ui.container).length){
                return;
            }

            // load settings
            this.url.theme = $(this.ui.container).attr('data-theme-url');
            this.url.submit = $(this.ui.container).attr('data-submit-url');
            this.url.logout = $(this.ui.container).attr('data-logout-url');
            this.page_id = $(this.ui.container).attr('data-page-id');
            this.defaultErrorMessage = $(this.ui.container).attr('data-default-error-message');
            this.stripe = Stripe($(this.ui.container).attr('data-stripe-key'), {
                locale: $(this.ui.container).attr('data-locale'),
            });
            this.recaptchaSiteKey = $(this.ui.container).attr('data-recaptcha-site-key');
            this.defaultStep = $(this.ui.container).attr('data-default-step');

            // create Stripe elements
            this._createStripeElements();

            // children
            this.Steps.ready(this);
            this.StickySizing.ready(this);

            // bind
            $(document).on('click', this.ui.submit, function(e){
                e.preventDefault();
                self.next();
            });
            $(document).on('click', this.ui.stepNav, function(e){
                e.preventDefault();
                self.goBackTo($(this).attr('data-step-id'));
            });
            $(document).on('change keypress blur', this.ui.container, function(e){
                // let inputmask update the value
                setTimeout(function(){
                    self.update();
                }, 20);
            });
            $(document).on('change', this.ui.checkboxToggle, function(e){
                var $content = $(self.ui.checkboxToggleContent)
                    .filter('[data-content-id="' + $(this).attr('data-content-id')  + '"]');
                if ($(this).is(':checked')){
                    $content.addClass('active')
                }else{
                    $content.removeClass('active')
                }
            });
            $(document).on('click', this.ui.logout, function(e){
                self.logout();
            });

            // init
            this._goToStepByIndex(0);
            $(this.ui.container).addClass('ready');

            // skip first step, if requested
            if(this.defaultStep == 1){
                this.next();
            }

        },
        next: function(){

            var self = this;

            // reached the end of steps
            if (this.currentStepIndex >= this.Steps.count() - 1){
                return;
            }

            // get current step
            var step = this.getCurrentStep();

            // validate current step
            if(!step.validate()){
                return;
            }

            // save current values
            this.values = $.extend(this.values, step.values());

            // submit this step
            if (step.submit){
                step.submit(this.values);
            }

            // go to next step
            self._goToStepByIndex(self.currentStepIndex + 1);

        },
        goBackTo: function(id){

            var requestedIndex = this.Steps.getIndex(id);

            if(requestedIndex === false || requestedIndex > this.currentStepIndex){
                return false;
            }

            this._goToStep(id);

        },
        getCurrentStep: function(){

            return this.Steps.get(this.currentStepIndex);

        },
        update: function(){

            var self = this;

            // available
            if (this.getCurrentStep().validate()){
                $(this.ui.submit).addClass('active');
                $(this.ui.paymentRequestButton).addClass('active');
            }else{
                $(this.ui.submit).removeClass('active');
                $(this.ui.paymentRequestButton).removeClass('active');
            }

            // hide header nav
            if (this.getCurrentStep().hideHeader){
                $(this.ui.nav).addClass('hidden');
            }else{
                $(this.ui.nav).removeClass('hidden');
            }
            // disable header nav
            if (this.getCurrentStep().disableHeader){
                $(this.ui.nav).addClass('disabled');
            }else{
                $(this.ui.nav).removeClass('disabled');
            }

            // update sizing
            // update size
            setTimeout(function(){
                self.StickySizing.update();
            }, 20);

        },
        submit: function(){

            var self = this;

            if (this.values.payment_method === 'credit-card' && this.values.frequency === 'regular') {
                this._createStripePaymentMethod(function (stripeResult) {
                    self.values.stripe_payment_method = stripeResult.paymentMethod.id;
                    self._submitToServer();
                }, function (stripeResult) {
                    // show error
                    self.showError('stripe-failed', stripeResult.error.message);
                });
            }else{
                this._submitToServer();
            }

        },
        logout: function(){

            $.get(this.url.logout, {
                u: new Date().getTime()
            });

        },
        _submitToServer: function(){

            var self = this;

            // validate the request by reCaptcha
            grecaptcha.ready(function() {
                grecaptcha.execute(self.recaptchaSiteKey, {action: 'donate'}).then(function(recaptchaToken) {

                    // submit data
                    $.post(
                        self.url.submit,
                        $.extend(self.values, {page_id: self.page_id, recaptcha_token: recaptchaToken}),
                        function(result){
                            self._processServerResult(result);
                        });

                });
            });

        },
        _processServerResult: function(result){

            var self = this;

            // reset all errors
            this.hideAllErrors();

            if (result.success){
                switch (result.payment.method){
                    case 'credit-card':
                        // single payment
                        this._confirmStripePayment(result.payment.stripe_client_secret, {
                            card: this.stripeElements.card,
                            // billing_details: {
                            //     // TODOd https://stripe.com/docs/payments/accept-a-payment?ui=elements
                            // }
                        }, function(stripeResult){
                            // show thank you page
                            self.values.result = result;
                            self.next();
                        }, function(stripeResult){
                            // show error
                            self.showError('stripe-failed', stripeResult.error.message);
                        });
                        break;
                    case 'google-pay':
                    case 'apple-pay':
                        // notify browser UI
                        self.stripePaymentRequestEvent.complete('success');
                        // confirm payment
                        this._confirmStripePayment(result.payment.stripe_client_secret, this.values.stripe_payment_method, function(stripeResult){
                            // show thank you page
                            self.values.result = result;
                            self.next();
                        }, function(stripeResult){
                            // show error
                            self.showError('stripe-failed', stripeResult.error.message);
                        });
                        break;
                    case 'bank-account':
                    default:
                        // show thank you page
                        this.values.result = result;
                        this.next();
                        break;
                }
            }else{
                switch (this.values.payment_method){
                    case 'google-pay':
                    case 'apple-pay':
                        // notify browser UI
                        this.stripePaymentRequestEvent.complete('fail');
                        break;
                }
                if (result.error){
                    this.showError(result.error, result.message);
                }else{
                    this.showError('unknown-error');
                }
            }

            // track
            Tools.Tracking.track('submit', 'show', {
                frequency: this.values.frequency,
                amount: this.values.amount,
                currency: this.values.currency,
                currency_code: this.values.currency_code,
                payment_method: this.values.payment_method,
            });

        },
        _confirmStripePayment: function(clientSecret, paymentMethod, success, error){

            this.stripe.confirmCardPayment(clientSecret, {
                payment_method: paymentMethod
            }).then(function(result) {
                if (result.error) {
                    error(result);
                } else {
                    if (result.paymentIntent.status === 'succeeded') {
                        success(result);
                    }
                }
            });

        },
        _createStripePaymentMethod: function (success, error){

            this.stripe.createPaymentMethod({
                type: 'card',
                card: this.stripeElements.card,
                // billing_details: {
                //     // TODOd https://stripe.com/docs/payments/accept-a-payment?ui=elements
                // }
            }).then(function(result) {
                if (result.error) {
                    error(result);
                } else {
                    success(result);
                }
            });

        },
        _createStripePaymentRequest: function(){

            var self = this;

            // create payment request
            var paymentRequest = this.stripe.paymentRequest({
                country: $(this.ui.container).attr('data-country'),
                currency: this.values.currency_code,
                total: {
                    label: 'Magna',
                    amount: Math.round(this.values.amount * 100), // in cents
                },
                requestPayerName: true,
                requestPayerEmail: true,
            });

            // check if available
            var paymentRequestButton = this._createStripePaymentRequestButton(paymentRequest);
            this.Steps.Payment.disableApplePlay();
            this.Steps.Payment.disableGooglePlay();
            paymentRequest.canMakePayment().then(function(result){
                if (result && result.applePay){
                    paymentRequestButton.mount(self.ui.paymentRequestButton);
                    self.Steps.Payment.enableApplePlay();
                }else if(result && result.googlePay){
                    paymentRequestButton.mount(self.ui.paymentRequestButton);
                    self.Steps.Payment.enableGooglePlay();
                }
            });

            // submit event
            paymentRequest.on('paymentmethod', function(e) {
                // pre-fill the provided name and email
                self.Steps.Personal.fillEmail(e.payerEmail);
                self.Steps.Personal.fillName(e.payerName);
                // fill
                // save Stripe payment method ID
                self.values.stripe_payment_method = e.paymentMethod.id;
                self.stripePaymentRequestEvent = e;
                self.next();
            });

        },
        hideAllErrors: function(){

            this.Steps.each(function(step){
                if (typeof step.hideErrors === 'function'){
                    step.hideErrors();
                }
            });

        },
        showError: function(error, message){

            switch (error){
                case 'invalid-credentials':
                    this._goToStep('Personal');
                    this.getCurrentStep().showLoginOption('sign-in');
                    this.getCurrentStep().showError(message);
                    break;
                case 'user-exists':
                    this._goToStep('Personal');
                    this.getCurrentStep().showLoginOption('sign-up');
                    this.getCurrentStep().showError(message);
                    break;
                case 'terms-required':
                    this._goToStep('Personal');
                    this.getCurrentStep().showLoginOption('sign-up');
                    this.getCurrentStep().showError(message);
                    break;
                case 'stripe-failed':
                    this._goToStep('Payment');
                    this.getCurrentStep().showError(message);
                    break;
                case 'unknown-error':
                default:
                    this._goToStep('Personal');
                    this.getCurrentStep().showError(message ? message : this.defaultErrorMessage);
                    break;
            }

        },
        _goToStep: function(id){

            this.currentStepIndex = this.Steps.getIndex(id);
            $(this.ui.stepNav).removeClass('active').filter('[data-step-id="' + id + '"]').addClass('active');

            $(this.ui.step).removeClass('active');
            this.Steps[id].$step.addClass('active');

            // update step
            this.getCurrentStep().show();

            // update submit state
            this.update();

            // track
            Tools.Tracking.track('step/' + id.toLowerCase() + '/show', 'show');

        },
        _goToStepByIndex: function(index){

            this._goToStep(this.Steps.get(index).id);

        },
        _createStripeElements: function(){

            var elements = this.stripe.elements({
                fonts: [
                    {
                        family: 'Guardian',
                        src: 'url(' + this.url.theme + '/public/font/GuardianTextSans-Regular-Web.woff) format("woff")',
                    },
                ]
            });
            var style = {
                base: {
                    color: "#000",
                    fontSize: "20px",
                    fontFamily: "Guardian, sans-serif",
                    '::placeholder': {
                        color: '#737373',
                    },
                },
                complete: {
                    iconColor: '#618b30',
                },
                invalid: {
                    iconColor: '#dc181b',
                    color: '#dc181b',
                },
            };

            this.stripeElements.card = elements.create("card", { hidePostalCode: true, style: style });
            this.stripeElements.card.mount(this.ui.cardForm);

        },
        _createStripePaymentRequestButton: function(paymentRequest){

            var elements = this.stripe.elements({
                fonts: [
                    {
                        family: 'Guardian',
                        src: 'url(' + this.url.theme + '/public/font/GuardianTextSans-Regular-Web.woff) format("woff")',
                    },
                ]
            });

            return elements.create('paymentRequestButton', { paymentRequest: paymentRequest, });

        },
        // STEPS
        Steps: {
            // First step - amount
            order: ['Amount', 'Payment', 'Personal', 'Processing', 'Thanks'],
            ready: function(donate){

                // init steps
                this.each(function(step, name){
                    // init properties
                    step.$step = $(donate.ui.step).filter('[data-step-id="' + name + '"]');
                    step.donate = donate;
                    step.id = name;
                    // init callback
                    step.ready();
                });

            },
            each: function(callback){

                // init steps
                for(var z in this.order){
                    if(!this.order.hasOwnProperty(z)){
                        continue;
                    }
                    var name = this.order[z];
                    callback(this[name], this.order[z]);
                }

            },
            get: function(index){

                if (!this.order[index]){
                    return false;
                }

                var name = this.order[index];
                return this[name];

            },
            getIndex: function(id){

                var index = _.invert(this.order)[id];

                return typeof index !== 'undefined' ? parseInt(index) : false;

            },
            count: function(){

                return this.order.length;

            },
            Amount: {
                id: null,
                donate: null,
                $step: null,
                ready: function(){

                    var self = this;

                    // toggle alternative contents
                    $(this.donate.ui.toggleContent, this.$step).click(function(e){
                        e.preventDefault();
                        // toggle links
                        self.$step.find(self.donate.ui.toggleContent).removeClass('active')
                            .filter('[data-content-id="' + $(this).attr('data-content-id')  + '"]').addClass('active');
                        // content
                        self.$step.find(self.donate.ui.alternativeContent).removeClass('active')
                            .filter('[data-content-id="' + $(this).attr('data-content-id')  + '"]').addClass('active');
                        // update
                        self.donate.update();
                    });

                },
                validate: function(){

                    var tab = this.$step.find('.js-donate__alternative-content.active').attr('data-content-id');
                    var amount = this.$step.find('.js-donate__alternative-content.active').find('.js-amount:checked').val();
                    var amountCustom = this.$step.find('.js-donate__alternative-content.active').find('.js-amount-custom').val();
                    amountCustom = (typeof amountCustom !== 'undefined') ? parseInt(amountCustom.replaceAll(' ', '')) : null;
                    var amountCustomMin = parseInt(this.$step.find('.js-donate__alternative-content.active').find('.js-amount-custom').attr('data-min'));
                    amountCustomMin = (typeof amountCustomMin !== 'undefined') ? parseInt(amountCustomMin) : null;

                    if (!amount){
                        return false;
                    }

                    if (amount === 'custom' && (!amountCustom || amountCustom < amountCustomMin)){
                        return false;
                    }

                    return true;

                },
                values: function($step){

                    var tab = this.$step.find('.js-donate__alternative-content.active').attr('data-content-id');
                    var amount = this.$step.find('.js-donate__alternative-content.active').find('.js-amount:checked').val().replace(',', '.');
                    var currency = this.$step.find('.js-donate__alternative-content.active').find('.js-amount:checked').attr('data-currency');
                    var currencyCode = this.$step.find('.js-donate__alternative-content.active').find('.js-amount:checked').attr('data-currency-code');

                    if (amount === 'custom'){
                        return {
                            frequency: tab,
                            amount: parseInt(this.$step.find('.js-donate__alternative-content.active').find('.js-amount-custom').val().replaceAll(' ', '')),
                            currency: currency,
                            currency_code: currencyCode,
                        };
                    }else{
                        return {
                            frequency: tab,
                            amount: parseFloat(amount),
                            currency: currency,
                            currency_code: currencyCode,
                        };
                    }

                },
                show: function(){},
                submit: function(values, success){

                    // init payment request buttons (Apple Pay / Google Pay)
                    this.donate._createStripePaymentRequest();

                },
            },
            Payment: {
                id: null,
                donate: null,
                $step: null,
                ui: {
                    pair: '.js-payment-method-container',
                    input: '.js-payment-method',
                    form: '.js-payment-method-form',
                },
                ready: function(){

                    $(this.ui.input).change(this._update.bind(this));
                    this._update();

                },
                showError: function(message){

                    // create message
                    var $error = $('<div class="e-message e-message--error" />').text(message);

                    // append
                    var $messages = $(this.donate.ui.messages, this.$step).filter(':visible').append($error);

                    // scroll to, if not visible
                    if ($messages.offset().top > $(window).scrollTop() + $(window).height() ||
                        $messages.offset().top < $(window).scrollTop()){
                        Tools.Scroller.scrollToOffset($messages.offset().top - 150);
                    }

                },
                hideErrors: function(){

                    $(this.donate.ui.messages, this.$step).empty();

                },
                _update: function(){

                    var paymentMethod = this.$step.find(this.ui.input).filter(':checked').val();
                    $(this.ui.form, this.$step).removeClass('active')
                        .filter('[data-payment-method="' + paymentMethod + '"]').addClass('active');

                },
                validate: function(){

                    var paymentMethod = this.$step.find(this.ui.input).filter(':checked').val();

                    if (!paymentMethod){
                        return false;
                    }

                    return true;

                },
                values: function(){

                    var paymentMethod = this.$step.find(this.ui.input).filter(':checked').val();

                    return {payment_method: paymentMethod};

                },
                show: function(){

                    var self = this;

                    // show correct content
                    var $intro = $(this.donate.ui.alternativeContent, this.$step)
                        .removeClass('active')
                        .filter('[data-content-id="' + this.donate.values.frequency + '"]')
                        .addClass('active');
                    var $content = $(this.donate.ui.dynamicContent, $intro);

                    $content.html($content.attr('data-html').replaceAll('[AMOUNT]', this.donate.values.amount + '&nbsp;' + this.donate.values.currency));

                },
                disableApplePlay: function(){

                    $(this.ui.input).filter('[value="apple-pay"]').closest(this.ui.pair).hide();

                },
                disableGooglePlay: function(){

                    $(this.ui.input).filter('[value="google-pay"]').closest(this.ui.pair).hide();

                },
                enableApplePlay: function(){

                    $(this.ui.input).filter('[value="apple-pay"]').closest(this.ui.pair).show();

                },
                enableGooglePlay: function(){

                    $(this.ui.input).filter('[value="google-pay"]').closest(this.ui.pair).show();

                },
            },
            Personal: {
                ui: {
                    'personalInfo': '.js-donate__personal-info',
                },
                id: null,
                donate: null,
                $step: null,
                ready: function(){

                    var self = this;

                    // toggle alternative contents
                    $(this.donate.ui.toggleContent, this.$step).click(function(e){
                        e.preventDefault();
                        self.showLoginOption($(this).attr('data-content-id'));
                    });

                },
                showLoginOption: function(id){

                    // content
                    this.$step.find(this.donate.ui.alternativeContent).removeClass('active')
                        .filter('[data-content-id="' + id  + '"]').addClass('active');

                    // update state
                    this.donate.update();

                },
                showError: function(message){

                    // create message
                    var $error = $('<div class="e-message e-message--error" />').text(message);

                    // append
                    var $messages = $(this.donate.ui.messages, this.$step).filter(':visible').append($error);

                    // scroll to, if not visible
                    if ($messages.offset().top > $(window).scrollTop() + $(window).height() ||
                        $messages.offset().top < $(window).scrollTop()){
                        Tools.Scroller.scrollToOffset($messages.offset().top - 150);
                    }

                },
                hideErrors: function(){

                    $(this.donate.ui.messages, this.$step).empty();

                },
                fillEmail: function(email){

                    this.$step.find('[name="email"]').val(email);

                },
                fillName: function(name){

                    var names = name.split(' ').filter(String);

                    if (names.length > 1){
                        var firstName = names[0];
                        var lastName = names.slice(1).join(' ');
                    }else{
                        var firstName = 'N/A';
                        var lastName = names.join(' ');
                    }

                    this.$step.find('[name="first_name"]').val(firstName);
                    this.$step.find('[name="last_name"]').val(lastName);

                },
                showAgreementOnly: function(){

                    $(this.ui.personalInfo, this.$step).hide();

                },
                showAll: function(){

                    $(this.ui.personalInfo, this.$step).show();

                },
                _getData: function(){

                    return {
                        login: {
                            email: this.$step.find('[name="login_email"]').val(),
                            password: this.$step.find('[name="login_password"]').val(),
                        },
                        personal: {
                            first_name: this.$step.find('[name="first_name"]').val(),
                            last_name: this.$step.find('[name="last_name"]').val(),
                            email: this.$step.find('[name="email"]').val(),
                            phone: this.$step.find('[name="phone"]').val(),
                            address: this.$step.find('[name="address"]').val(),
                            zip: this.$step.find('[name="zip"]').val(),
                            city: this.$step.find('[name="city"]').val(),
                            agree_terms: this.$step.find('[name="agree_terms"]').is(':checked'),
                        },
                        company: {
                            is_company: this.$step.find('[name="is_company"]').is(':checked'),
                            company_name: this.$step.find('[name="company_name"]').val(),
                            company_id: this.$step.find('[name="company_id"]').val(),
                            company_tax_id: this.$step.find('[name="company_tax_id"]').val(),
                        },
                        profile_picture: {
                            file: this.$step.find('[name="profile_picture"]').val(),
                        }
                    };

                },
                validate: function(){

                    var tab = this.$step.find('.js-donate__alternative-content.active').attr('data-content-id');
                    var data = this._getData();

                    // require profile picture, if it is present
                    if(this.$step.find('[name="profile_picture"]').length && !data.profile_picture.file){
                        return false;
                    }

                    switch (tab){
                        case 'current-user':
                            return true;
                        case 'sign-up':
                            if (['apple-pay', 'google-pay'].indexOf(this.donate.values.payment_method) !== -1){
                                // Google pay and Apple pay
                                return !!data.personal.agree_terms;
                            }else{
                                // other methods
                                if (data.company.is_company && (
                                    !data.company.company_name
                                )){
                                    return false;
                                }
                                return data.personal.first_name &&
                                    data.personal.last_name &&
                                    data.personal.email &&
                                    /\S+@\S+\.\S+/.test(data.personal.email) &&
                                    data.personal.agree_terms;
                            }
                        case 'sign-in':
                            return data.login.email && /\S+@\S+\.\S+/.test(data.login.email) && data.login.password;
                    }

                    return false;

                },
                values: function(){

                    var tab = this.$step.find('.js-donate__alternative-content.active').attr('data-content-id');
                    var data = this._getData();

                    switch (tab){
                        case 'current-user':
                            var details = {};
                            break;
                        case 'sign-up':
                            var details = data.company.is_company ? $.extend(data.personal, data.company) : data.personal;
                            break;
                        case 'sign-in':
                            var details = data.login;
                            break;
                    }

                    if(data.profile_picture.file){
                        details.profile_picture = data.profile_picture.file;
                    }

                    return $.extend({user: tab}, details);

                },
                show: function(){

                    if (['apple-pay', 'google-pay'].indexOf(this.donate.values.payment_method) === -1){
                        // show basic submit button, hide Stripe payment request button
                        $(this.donate.ui.submit, this.$step).show();
                        $(this.donate.ui.paymentRequestButton, this.$step).hide();

                        // show customized submit button text
                        var $submitText = $(this.donate.ui.submit, this.$step).find('span');
                        var template = $submitText.attr('data-template');
                        var frequency = $submitText.attr('data-frequency-' + this.donate.values.frequency);
                        var label = template.replace('%amount%', this.donate.values.amount + '&nbsp;' + this.donate.values.currency)
                                    .replace('%frequency%', frequency ? frequency : '');
                        $submitText.html(label);

                        this.showAll();
                    }else{
                        // hide basic submit button, show Stripe payment request button
                        $(this.donate.ui.submit, this.$step).hide();
                        $(this.donate.ui.paymentRequestButton, this.$step).show();
                        this.showAgreementOnly();
                    }

                },
                submit: function(values, success){

                    // submit all data
                    this.donate.submit();

                    // show processing loader
                    return true;

                },
            },
            Processing: {
                id: null,
                donate: null,
                $step: null,
                disableHeader: true,
                ready: function(){},
                validate: function(){ return true; },
                values: function(){ return {}; },
                show: function(){}
            },
            Thanks: {
                id: null,
                donate: null,
                $step: null,
                hideHeader: true,
                ready: function(){},
                validate: function(){},
                values: function(){},
                show: function(){

                    // load info
                    var payment = this.donate.values.result.payment;

                    // show correct thank you info per payment type
                    var active = 'other';
                    switch (payment.method){
                        case 'bank-account':
                            if (payment.frequency === 'monthly'){
                                active = 'bank-account-regular';
                            }else{
                                active = 'bank-account-single';
                            }
                            break;
                        case 'credit-cart':
                        default:
                            // leave 'other'
                            break;
                    }

                    // show content
                    var $contents = $(this.donate.ui.alternativeContent, this.$step)
                        .removeClass('active')
                        .filter('[data-content-id="' + active + '"]')
                        .addClass('active');

                    // fill values
                    $(this.donate.ui.thanksAmount, $contents).html(payment.amount + '&nbsp;' + payment.currency);
                    $(this.donate.ui.thanksPaymentReference, $contents).text(payment.reference);

                }
            }
        },
        StickySizing: {
            ui:{
                track: '.js-donate__sticky-track',
                form: '.js-donate__sticky-form',
            },
            donate: null,
            ready: function(donate){

                var self = this;

                this.donate = donate;

                this.update();
                $(window).on('resize', this.update.bind(this));

                setInterval(function(){
                    self.update();
                }, 100);

            },
            update: function (){

                var $container = $(this.donate.ui.container);
                var $form = $(this.ui.form);
                var $track = $(this.ui.track);

                $container.css('min-height', $form.outerHeight(true) + 'px');
                $track.css('height', $container.height() + 'px');

                if($container.hasClass('s-donate--full-image')){
                    $container.css('height', $form.outerHeight(true) + 'px');
                }

            }
        }
    };

})(jQuery);